<template>
  <div class="d-flex align-start">
    <v-select
      class="flex-grow-1"
      :value="value"
      :items="items"
      item-value="key"
      item-text="title"
      :label="label"
      :disabled="disabled"
      :loading="loading"
      outlined
      @input="$emit('input', $event)"
    >
      <template #item="{ item }">
        <v-list-item-content>
          <v-list-item-title v-text="item.title" />
        </v-list-item-content>
        <v-list-item-action v-if="item.url">
          <v-btn
            outlined
            icon
            small
            @click.stop="togglePreview(item)"
          >
            <v-icon>{{ playingKey === item.key ? 'mdi-stop' : 'mdi-play' }}</v-icon>
          </v-btn>
        </v-list-item-action>
      </template>
    </v-select>
    <!-- Вне v-select: у disabled-поля Vuetify отключает pointer-events на всём .v-input -->
    <v-btn
      class="ml-2 mt-2"
      icon
      :disabled="!selectedPreset"
      @click="togglePreview(selectedPreset)"
    >
      <v-icon>{{ selectedPreset && playingKey === selectedPreset.key ? 'mdi-stop' : 'mdi-play' }}</v-icon>
    </v-btn>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { NO_SOUND } from '@/constants/sounds'
  import { createSound } from '@/util/sound'

  export default {
    name: 'SoundSelectSettings',
    props: {
      value: { type: String, default: null },
      label: { type: String, default: '' },
      disabled: Boolean,
    },
    data () {
      return {
        loading: false,
        preview: null,
        playingKey: null,
      }
    },
    computed: {
      ...mapGetters({ presets: 'sounds/getPresets' }),
      items () {
        return [{ key: NO_SOUND, title: 'Без звука', url: null }, ...this.presets]
      },
      selectedPreset () {
        return this.presets.find((p) => p.key === this.value) || null
      },
    },
    async created () {
      this.loading = true
      try {
        await this.$store.dispatch('sounds/fetchPresets')
      } catch (e) {
        this.showErrorFromResponse(e)
      }
      this.loading = false
    },
    beforeDestroy () {
      this.stopPreview()
    },
    methods: {
      togglePreview (preset) {
        const wasPlaying = this.playingKey === preset.key
        this.stopPreview()

        if (wasPlaying) {
          return
        }

        this.preview = createSound(preset.url)
        this.preview.once('end', this.stopPreview)
        this.preview.once('loaderror', this.onPreviewError)
        this.preview.once('playerror', this.onPreviewError)
        this.preview.play()
        this.playingKey = preset.key
      },
      onPreviewError () {
        this.stopPreview()
        this.showErrorMessage('Не удалось воспроизвести звук')
      },
      stopPreview () {
        if (this.preview) {
          this.preview.unload()
        }
        this.preview = null
        this.playingKey = null
      },
    },
  }
</script>
